/*
eWorldES Proprietary Software
Copyright (C) 2025 eWorldES. All rights reserved.

This software is proprietary to eWorldES and is protected by copyright laws and international treaties.
You may not use, copy, modify, distribute, or disclose this software without explicit written permission from eWorldES.
Any unauthorized use or reproduction of this software is strictly prohibited and may result in legal action.

License Agreement:
By using this software, you agree to be bound by the terms of the eWorldES Proprietary Software License Agreement.
For a copy of the agreement, visit https://eworldes.com/ or contact eWorldES directly for more information.

This software is provided "AS IS" without warranty of any kind, express or implied, including but not limited to the warranties of
merchantability, fitness for a particular purpose, or non-infringement. In no event shall eWorldES be liable for any damages
arising out of the use of this software, even if eWorldES has been advised of the possibility of such damages.

For inquiries or requests regarding this software, please contact eWorldES at:
Email: info@eworldes.com
Website: https://eworldes.com/
*/
import FormControl from "@mui/material/FormControl";
import { Controller } from "react-hook-form";
import { InputFieldProps } from "../../types/InputProps";
import InputWrapper from "./InputWrapper";
import { FormLabel, styled, TextareaAutosize as TextArea } from "@mui/material";

const TextareaAutosize = styled(TextArea)(
  ({ theme }) => `
  box-sizing: border-box;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 8px 12px;
  border-radius: 8px;
  color: ${theme.palette.mode === "dark" ? "#C7D0DD" : "#1C2025"};
  // background: ${theme.palette.mode === "dark" ? "#1C2025" : "#fff"};
  background: transparent;
  border: 1px solid ${theme.palette.mode === "dark" ? "#434D5B" : "#DAE2ED"};
  box-shadow: 0 2px 2px ${theme.palette.mode === "dark" ? "#1C2025" : "#F3F6F9"};

  &:hover {
    border-color: ${"#3399FF"};
  }

  &:focus {
    border-color: ${"#3399FF"};
    box-shadow: 0 0 0 3px ${theme.palette.mode === "dark" ? "#0072E5" : "#b6daff"};
  }

  /* firefox */
  &:focus-visible {
    outline: 0;
  }
`,
);

export const FormTextArea = (props: InputFieldProps) => {
  const { name, control, info, hint, meta, label, validations = [] } = props;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <InputWrapper info={info} hint={hint} error={error}>
          <FormControl fullWidth>
            <FormLabel
              style={{ marginBottom: 3 }}
              required={validations.length > 0}
            >
              {label}
            </FormLabel>
            <TextareaAutosize
              onChange={onChange}
              value={value}
              minRows={5}
              {...meta}
            />
          </FormControl>
        </InputWrapper>
      )}
    />
  );
};

export default FormTextArea;
